module.exports = __webpack_public_path__ + "img/horizontal_7_1_pp1_8019.58f9a47f.png";